import * as Yup from 'yup';

export default function addPatientModalValidation(t) {
  // We define our schema based on the same keys as our form:
  return Yup.object().shape({
    firstName: Yup.string().required(t('common.registrationFormValidations.firstName')),
    lastName: Yup.string().required(t('common.registrationFormValidations.lastName')),
    email: Yup.string().email(t('common.registrationFormValidations.email'))
      .required(t('common.registrationFormValidations.emailEmpty')),
    idNumber: Yup.string().matches(/^[0-9]{13}$/, {
      message: t('common.registrationFormValidations.idnumberInvalid')
    }).required(t('common.registrationFormValidations.idNumber')),
    address: Yup.string().required(t('common.registrationFormValidations.address')),
    countyId: Yup.string().required(t('common.registrationFormValidations.county')),
    cityId: Yup.string().required(t('common.registrationFormValidations.city')).nullable(),
    phone: Yup.string().matches(/^[0-9]{10}$/, {
      message: t('common.registrationFormValidations.phoneInvalid')
    }).required(t('common.registrationFormValidations.phone'))
  });
};
